import { render } from "./ConfirmationRdv.vue?vue&type=template&id=4961f9f4&scoped=true"
import script from "./ConfirmationRdv.vue?vue&type=script&lang=js"
export * from "./ConfirmationRdv.vue?vue&type=script&lang=js"

import "./ConfirmationRdv.vue?vue&type=style&index=0&id=4961f9f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4961f9f4"

export default script